import gql from 'graphql-tag'

import { FRAGMENT_PROJECT_CARD_ITEM, FRAGMENT_PUBLICATION_CARD_ITEM } from './shared.gql'

export const QUERY_PROJECT_CARDS = gql`
  ${FRAGMENT_PROJECT_CARD_ITEM}

  query ProjectCards($locale: LocaleInputType!, $limit: Int!, $page: Int!, $categories: Project_categories_operator) {
    Projects(
      locale: $locale
      limit: $limit
      page: $page
      draft: false
      trash: false
      where: { categories: $categories, _status: { equals: published } }
    ) {
      limit
      page
      totalDocs
      totalPages
      docs {
        ...ProjectCardItem
      }
    }
  }
`

export const QUERY_PUBLICATION_CARDS = gql`
  ${FRAGMENT_PUBLICATION_CARD_ITEM}

  query PublicationCards(
    $locale: LocaleInputType!
    $limit: Int!
    $page: Int!
    $categories: Publication_categories_operator
  ) {
    Publications(
      locale: $locale
      limit: $limit
      page: $page
      sort: "-date"
      draft: false
      trash: false
      where: { categories: $categories, _status: { equals: published } }
    ) {
      limit
      page
      totalDocs
      totalPages
      docs {
        ...PublicationCardItem
      }
    }
  }
`
